import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  { path: '/users', name: 'users', component: () => import('../views/UsersView.vue') },
  { path: '/set-password', component: HomeView },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { keepAlive: true }
  },
  {
    path: '/teams',
    name: 'teams', 
    component: () => import('../views/TeamsView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/team/:teamName/:league?',
    name: 'TeamDetailView',
    component: () => import('../views/TeamInsightView.vue')
  },
  {
    path: '/tables',
    name: 'tables',
    component: () => import('../views/LeagueTables.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/fixtures',
    name: 'fixtures',
    component: () => import('../views/FixturesView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/uefa-points',
    name: 'uefa-points',
    component: () => import('../views/UefaPointsView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/points-ev',
    name: 'points-ev',
    component: () => import('../views/PointsEvolutionView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/uefa-associations',
    name: 'uefa-associations',
    component: () => import('../views/UefaAssociationsView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/competitions',
    name: 'competitions',
    component: () => import('../views/CompetitionsView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/uefa-club-names',
    name: 'uefa-club-names',
    component: () => import('../views/UefaClubNamesView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/season-config',
    name: 'season-config',
    component: () => import('../views/SeasonConfigView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/season-history',
    name: 'season-history',
    component: () => import('../views/SeasonHistoryView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/api-data-management',
    name: 'api-data-management',
    component: () => import('../views/ApiDataManagementView.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/kassiesa-monitor',
    name: 'kassiesa-monitor',
    component: () => import('../views/KassiesaMonitorView.vue'),
    meta: { keepAlive: true }
  }
]

const scrollPositions = new Map()

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    const remembered = scrollPositions.get(to.fullPath)
    if (remembered) return remembered
    return { left: 0, top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (from?.fullPath) {
    scrollPositions.set(from.fullPath, {
      left: window.scrollX || 0,
      top: window.scrollY || 0
    })
  }
  next()
})

export default router
